import { relations, sql } from "drizzle-orm";
import { boolean, jsonb, pgTable, text, timestamp, uuid, } from "drizzle-orm/pg-core";
import { appUser } from "./main.js";
export const notification = pgTable("notification", {
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    type: text().notNull().$type(),
    recipientUserId: uuid().notNull(),
    metadata: jsonb().notNull().$type(),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .notNull()
        .defaultNow(),
    read: boolean().notNull().default(false),
});
export const notificationRelations = relations(notification, ({ one }) => ({
    recipient: one(appUser, {
        fields: [notification.recipientUserId],
        references: [appUser.id],
    }),
}));
